import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SettingsAiRuntime } from '../../../../shared/services/settings/settings.service';

export const settingsAiActions = createActionGroup({
  source: 'Settings AI',
  events: {
    'load settings ai': emptyProps(),
    'load settings ai success': props<{ settings: SettingsAiRuntime }>(),
    'load settings ai failure': props<{ error: string }>(),

    'update settings ai': props<{ dto: Partial<SettingsAiRuntime> }>(),
    'update settings ai success': props<{ settings: SettingsAiRuntime }>(),
    'update settings ai failure': props<{ error: string }>(),
  },
});
